import type * as React from 'react';
import { get } from '@Domain/Api';
import recordingPolicyFetched, {
	type RecordingPolicyFetchedAction,
	type RecordingPolicyPayload,
} from '@Application/RecordingPolicy/Actions/recordingPolicyFetched';
import recordingPolicyFetchFailed, {
	type RecordingPolicyFetchFailedAction,
} from '@Application/RecordingPolicy/Actions/recordingPolicyFetchFailed';
import recordDeviceRetention from '@Application/RecordingPolicy/recordDeviceRetention';
import type FetchRecordingPolicy from '@Application/RecordingPolicy/Queries/FetchRecordingPolicy';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../parameters';

type Actions = RecordingPolicyFetchedAction | RecordingPolicyFetchFailedAction;

/**
 * Persists `deviceRetentionMs` on the device before dispatching: this is the only writer of that
 * value, and it is what lets `readDeviceRetention` answer offline on the next session's very first
 * render, without waiting for this call to ever resolve again.
 */
export default (_query: FetchRecordingPolicy) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await get<RecordingPolicyPayload>(`${parameters.api.host}/api/recording-policy`);

			recordDeviceRetention(payload.deviceRetentionMs);

			const action = recordingPolicyFetched(payload);
			dispatch(action);
			return action;
		} catch (error) {
			const action = recordingPolicyFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
